import {inject, injectable} from "inversify";
import {GroundSlotType} from "@/modules/club-grounds/types";
import {EffectTypeEnum, GroundSlotTypeEnum} from "@/modules/club-grounds/enums";
import {ColorEnum} from "@/modules/vue/enums";
import {ConfigRepository} from "@/modules/base/services/ConfigRepository";
import {GroundSlot} from "@/modules/club-grounds/entity";

@injectable()
export default class GroundSlotConfigProvider {
  constructor(
    @inject(ConfigRepository) private configRepository: ConfigRepository,
  ) {
  }

  public get(groundSlot: GroundSlot): GroundSlotType[] {
    return [
      {
        id: GroundSlotTypeEnum.OFFICE,
        color: ColorEnum.Indigo,
        price: this.configRepository.get('clubGrounds.costs.develop')(groundSlot, GroundSlotTypeEnum.OFFICE),
        duration: this.configRepository.get('clubGrounds.durations.develop')(groundSlot, GroundSlotTypeEnum.OFFICE),
        effects: [
          {
            type: EffectTypeEnum.STAFF_MEMBER_SLOTS,
            value: this.configRepository.get('clubGrounds.effects.office.additionalStaffMemberSlots'),
            label: translator.t('effect_staff_member_slots'),
          }
        ],
      },
      {
        id: GroundSlotTypeEnum.HEADQUATERS,
        color: ColorEnum.Sky,
        price: this.configRepository.get('clubGrounds.costs.develop')(groundSlot, GroundSlotTypeEnum.HEADQUATERS),
        duration: this.configRepository.get('clubGrounds.durations.develop')(groundSlot, GroundSlotTypeEnum.HEADQUATERS),
        effects: [
          {
            type: EffectTypeEnum.NEGOTIATION_PROGRESS,
            value: this.configRepository.get('clubGrounds.effects.headquaters.negotiationProgress'),
            label: translator.t('effect_negotiation_progress'),
            percent: true,
          }
        ],
      },
      {
        id: GroundSlotTypeEnum.PUBLIC_RELATIONS,
        color: ColorEnum.Purple,
        price: this.configRepository.get('clubGrounds.costs.develop')(groundSlot, GroundSlotTypeEnum.PUBLIC_RELATIONS),
        duration: this.configRepository.get('clubGrounds.durations.develop')(groundSlot, GroundSlotTypeEnum.PUBLIC_RELATIONS),
        effects: [
          {
            type: EffectTypeEnum.SPONSORING_BASE_OFFER,
            value: this.configRepository.get('clubGrounds.effects.publicRelations.sponsoringBaseOffer'),
            label: translator.t('effect_sponsoring_base_offer'),
            percent: true,
          }
        ],
      },
      {
        id: GroundSlotTypeEnum.SCOUTING,
        color: ColorEnum.Slate,
        price: this.configRepository.get('clubGrounds.costs.develop')(groundSlot, GroundSlotTypeEnum.SCOUTING),
        duration: this.configRepository.get('clubGrounds.durations.develop')(groundSlot, GroundSlotTypeEnum.SCOUTING),
        effects: [
          {
            type: EffectTypeEnum.SCOUTING_PROGRESS,
            value: this.configRepository.get('clubGrounds.effects.scouting.scoutingProgress'),
            label: translator.t('effect_scouting_progress'),
            percent: true,
          }
        ],
      },
      {
        id: GroundSlotTypeEnum.TRAINING,
        color: ColorEnum.Emerald,
        price: this.configRepository.get('clubGrounds.costs.develop')(groundSlot, GroundSlotTypeEnum.TRAINING),
        duration: this.configRepository.get('clubGrounds.durations.develop')(groundSlot, GroundSlotTypeEnum.TRAINING),
        effects: [
          {
            type: EffectTypeEnum.TRAINING_PROGRESS,
            value: this.configRepository.get('clubGrounds.effects.training.trainingProgress'),
            label: translator.t('effect_training_progress'),
            percent: true,
          }
        ],
      },
      {
        id: GroundSlotTypeEnum.YOUTH,
        color: ColorEnum.Lime,
        price: this.configRepository.get('clubGrounds.costs.develop')(groundSlot, GroundSlotTypeEnum.YOUTH),
        duration: this.configRepository.get('clubGrounds.durations.develop')(groundSlot, GroundSlotTypeEnum.YOUTH),
        effects: [
          {
            type: EffectTypeEnum.YOUTH_TRAINING_PROGRESS,
            value: this.configRepository.get('clubGrounds.effects.youth.trainingProgress'),
            label: translator.t('effect_youth_training_progress'),
            percent: true,
          }
        ],
      },
    ];
  }
}
